"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = require("../../../app-reduxs/login/slice");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const icons_1 = require("../../../assets/icons");
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const enums_1 = require("../../../constants/enums");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const User_1 = __importDefault(require("../../../networking/apis/User"));
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const NotifySettingScreen = (props) => {
    const { type } = props.route?.params;
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const dataUser = (0, react_redux_1.useSelector)(slice_1.selectProfile, react_redux_1.shallowEqual);
    const dispatch = (0, react_redux_1.useDispatch)();
    const [dataNoti, setDataNoti] = (0, react_1.useState)({
        message_from_mgmt: enums_1.Status.Inactive,
        follower: enums_1.Status.Inactive,
    });
    (0, react_1.useEffect)(() => {
        if (dataUser) {
            switch (type) {
                case enums_1.NotiType.PUSH_NOTI:
                    const { message_from_mgmt, follower } = dataUser.push_notification_setting;
                    setDataNoti({
                        message_from_mgmt,
                        follower,
                    });
                    break;
                case enums_1.NotiType.BOX_NOTI:
                    const boxNotificationSetting = dataUser.box_notification_setting;
                    setDataNoti({
                        message_from_mgmt: boxNotificationSetting.message_from_mgmt,
                        follower: boxNotificationSetting.follower,
                    });
                    break;
                default:
                    break;
            }
        }
    }, [dataUser]);
    const handleChangeSetting = async (formData) => {
        if (!dataUser)
            return;
        try {
            if (type == enums_1.NotiType.PUSH_NOTI) {
                const settingChangeData = await User_1.default.pushNotiSetting(formData);
                const newUser = {
                    ...dataUser,
                    push_notification_setting: {
                        ...dataUser.push_notification_setting,
                        ...settingChangeData.data,
                    },
                };
                dispatch((0, slice_1.setProfileAction)(newUser));
            }
            else {
                const settingChangeData = await User_1.default.boxNotiSetting(formData);
                const newUser = {
                    ...dataUser,
                    box_notification_setting: {
                        ...dataUser.box_notification_setting,
                        ...settingChangeData.data,
                    },
                };
                dispatch((0, slice_1.setProfileAction)(newUser));
            }
        }
        catch (err) {
            console.log(err);
        }
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                alignSelf: 'center',
            }, title: "\u5404\u7A2E\u901A\u77E5\u8A2D\u5B9A", styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, null) }),
        react_1.default.createElement(react_native_1.ScrollView, { contentContainerStyle: styles_1.default.body, showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.titleView },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.title }, type == enums_1.NotiType.PUSH_NOTI ? 'プッシュ通知' : 'アプリ内通知欄')),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.navigateView },
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles_1.default.navigateButton, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.TIMELINE_NOTIFY_SETTING, { type: type }) },
                    react_1.default.createElement(CustomText_1.default, { style: styles_1.default.navigateButtonLabel }, "\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3"),
                    react_1.default.createElement(icons_1.IC_ARROW_RIGHT, { width: (0, scale_1.scale)(20), height: (0, scale_1.scale)(20), color: "#292A33" }))),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.navigateView },
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles_1.default.navigateButton, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.ARTICLE_NOTIFY_SETTING, { type: type }) },
                    react_1.default.createElement(CustomText_1.default, { style: styles_1.default.navigateButtonLabel }, "\u8A18\u4E8B"),
                    react_1.default.createElement(icons_1.IC_ARROW_RIGHT, { width: (0, scale_1.scale)(20), height: (0, scale_1.scale)(20), color: "#292A33" }))),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.navigateView },
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles_1.default.navigateButton, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.PERSONAL_HISTORY_NOTIFY_SETTING, { type: type }) },
                    react_1.default.createElement(CustomText_1.default, { style: styles_1.default.navigateButtonLabel }, "\u81EA\u5206\u53F2"),
                    react_1.default.createElement(icons_1.IC_ARROW_RIGHT, { width: (0, scale_1.scale)(20), height: (0, scale_1.scale)(20), color: "#292A33" }))),
            react_1.default.createElement(components_1.SwitchView, { defaultValue: dataNoti.message_from_mgmt == enums_1.Status.Active, title: "\u904B\u55B6\u304B\u3089\u306E\u304A\u77E5\u3089\u305B", description: "\u304A\u5F97\u306A\u60C5\u5831\u306A\u3069\u904B\u55B6\u304B\u3089\u306E\u304A\u77E5\u3089\u305B\u901A\u77E5\u3092\u53D7\u3051\u53D6\u308C\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002", onChangeValue: (value) => {
                    handleChangeSetting({ message_from_mgmt: value });
                } }),
            react_1.default.createElement(components_1.SwitchView, { defaultValue: dataNoti?.follower == enums_1.Status.Active, title: "\u30D5\u30A9\u30ED\u30EF\u30FC\u901A\u77E5", description: "\u30D5\u30A9\u30ED\u30FC\u3055\u308C\u305F\u969B\u306B\u901A\u77E5", onChangeValue: (value) => {
                    handleChangeSetting({ follower: value });
                } }))));
};
exports.default = NotifySettingScreen;
